<template>

    <Page>

        <ImageAndText 
            src="/SuccessLeavesATrail/loyalty-programs.png"
            animation="slide-up"
            floor-shadow
            border>

            <h2 class="mb-4">All major consumer brands have loyalty programs</h2>
            <p class="font-normal text-white/80">
                Nearly all major consumer brands from airlines and supermarkets 
                to coffee chains and automotive dealerships leverage loyalty programs 
                because repeat customers spend more, stay longer, and are more 
                likely to refer others.
            </p>

        </ImageAndText>

    </Page>

</template>